import type { ComponentProps } from "react";
import type { DistributionSource, PublishingPlatform } from "~/core/api/distribution";
import { brandContracts } from "~/core/publishing";
import { PlatformComposer } from "./composer";
export function PublishingContentEditor(props: {
	source: DistributionSource;
	platform: PublishingPlatform;
	entityId: string;
	onStageChange?: (finishing: boolean) => void;
	taskId?: string;
	expandedPreview?: boolean;
	readOnly?: boolean;
	viewOnly?: boolean;
	seed?: ComponentProps<typeof PlatformComposer>["seed"];
	/** The kind of post, for a platform that takes several; its default when absent or unknown. */
	format?: string;
	onFormatChange?: (format: string) => void;
	saveDraft?: ComponentProps<typeof PlatformComposer>["saveDraft"];
}) {
	const contracts = brandContracts([props.platform]);
	const contract = contracts.kind(props.platform.id, props.format) ?? contracts.kind(props.platform.id);
	return contract ? (
		<PlatformComposer
			key={`${props.source.id}:${props.source.revision}:${contract.id}:${contract.format ?? ""}`}
			source={props.source}
			onStageChange={props.onStageChange}
			platform={contract}
			entityId={props.entityId}
			taskId={props.taskId}
			expandedPreview={props.expandedPreview}
			readOnly={props.readOnly}
			viewOnly={props.viewOnly}
			seed={props.seed}
			onFormatChange={props.onFormatChange}
			saveDraft={props.saveDraft}
		/>
	) : null;
}
